import { render, staticRenderFns } from "./ClientProfileScores.vue?vue&type=template&id=7a328361&"
import script from "./ClientProfileScores.vue?vue&type=script&lang=js&"
export * from "./ClientProfileScores.vue?vue&type=script&lang=js&"
import style0 from "./ClientProfileScores.vue?vue&type=style&index=0&id=7a328361&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports